/**
 * Daytime HQ call-receiver scheduling (office hours).
 *
 * Mirrors on-call window/booking shapes; stored in settingsJson for beta.
 */

import type {
  OnCallCustomBlock,
  OnCallOrgConfig,
  OnCallPeriod,
  OnCallRecurringBlock,
} from '../on-call/types'

export type DaytimeContactPeriod = OnCallPeriod
export type DaytimeRecurringBlock = OnCallRecurringBlock
export type DaytimeCustomBlock = OnCallCustomBlock
export type DaytimeOrgConfig = OnCallOrgConfig

/** settingsJson key for L4 admin timetable template. */
export const DAYTIME_ORG_CONFIG_KEY = 'daytimeOrgConfig' as const

/** settingsJson key for provider bookings within daytime windows. */
export const DAYTIME_BOOKINGS_KEY = 'daytimeBookings' as const
